import {getPercentage} from "./misc2";
import Config from "../config";
import {shouldRequestMarkUpForFeatures} from "../api/server-api";

export const MARK_UP_APPLY_TO_TYPES = { // QKB
  retailPrice: "retailPrice",
  cost: "cost",
  retailPriceAndCost: "retailPriceAndCost",
  shippingCost: "shippingCost",
  discount: "discount",
}

const MARK_UP_PROPS_MATCH = { // CAES
  Retail: "cost",
  Cost: "price",
  Discount: "fabricatorCost",
};

/**
 * @param dbFeaturesArray {[dbFeatureInterface]}
 * @param markUpResponse {object}
 * @param storeState {object}
 * @param shouldApplyGlobal {boolean}
 * @return {[dbFeatureInterface]}
 */
export const setResponseFeaturesMarkUp = (dbFeaturesArray, markUpResponse, storeState, shouldApplyGlobal = true) => {
  if (!Array.isArray(dbFeaturesArray)) {
    return dbFeaturesArray
  }
  if (shouldApplyGlobal && shouldRequestMarkUpForFeatures(dbFeaturesArray)) {
    dbFeaturesArray = setResponseFeaturesGlobalUseBaseMarkUp(dbFeaturesArray, storeState);
  }
  if ((typeof markUpResponse !== "object") || (markUpResponse === null) || !Object.keys(markUpResponse).length) {
    return dbFeaturesArray
  }
  if (Config.isDevMode()) {
    console.log("some features have markUpResponse");
  }
  Object.keys(markUpResponse).forEach(dbFeatureIdString => {
    const dbFeatureId = +dbFeatureIdString;
    let dbFeature = dbFeaturesArray.find(feature => feature.id === dbFeatureId);
    if (dbFeature && !dbFeature.markUpString) {
      // if (Config.isDevMode()) {
      //   console.log("featureWithMarkUp", dbFeature.customDisplayName, dbFeature);
      // }
      // here we update dbFeature with new mark up price! // no, we just set json string to dbFeature.markUpString
      dbFeature = setFeaturePriceFromMarkItemOnLoad(markUpResponse[dbFeatureIdString], dbFeature);
    }
  })
  return dbFeaturesArray
}

/**
 * @param dbFeaturesArray {[dbFeatureInterface]}
 * @param storeState {object}
 * @return {[dbFeatureInterface]}
 */
export const setResponseFeaturesGlobalUseBaseMarkUp = (dbFeaturesArray, storeState) => {
  if (!Array.isArray(dbFeaturesArray) || !storeState.cartState?.markUpLogic?.useBase) {
    return dbFeaturesArray
  }
  const {useBase} = storeState.cartState.markUpLogic;

  const mode = useBase === "useCostAsBase"
    ? { from: "price", to: "cost"}
    : { from: "cost", to: "price"}; // useRetailAsBase

  if (Config.isDevMode()) {
    console.log("PRICES were changed!", storeState.cartState.markUpLogic);
  }
  for (const dbFeature of dbFeaturesArray) {
    dbFeature[mode.to] = dbFeature[mode.from];
    // dbFeature.useCostBaseLogicApplied = true; // not used
  }

  return dbFeaturesArray
}

const getUpdatedFeaturePriceFromMarkItem = (markUpListItem, originalValue, isCaes = false) => {
  const type = isCaes ? markUpListItem.Type : markUpListItem.type;
  const priceType = isCaes ? markUpListItem.PriceType : markUpListItem.priceType;
  const value = isCaes ? markUpListItem.Value : markUpListItem.value;

  const changeValue = (priceType === "currency")
    ? +value
    : getPercentage(+originalValue, +value);
  let newValue = (type === "mark_up" || type === "MarkUp")
    ? +originalValue + changeValue
    : +originalValue - changeValue;
  return newValue < 0 ? 0 : +(newValue.toFixed(2));
}

/**
 * QKB set
 * @param markUpItem {object}
 * @param dbFeature {dbFeatureInterface}
 * @return {dbFeatureInterface}
 */
export const setFeaturePriceFromMarkItemQKB = (markUpItem, dbFeature) => {
  // console.log("markUpItem", markUpItem, newDbFeature);
  const {price, cost, shippingCost, discount} = markUpItem.originalValues;
  switch (markUpItem.applyTo) {
    case MARK_UP_APPLY_TO_TYPES.retailPrice: {
      dbFeature.price = getUpdatedFeaturePriceFromMarkItem(markUpItem, price);
      break;
    }
    case MARK_UP_APPLY_TO_TYPES.cost: {
      dbFeature.cost = getUpdatedFeaturePriceFromMarkItem(markUpItem, cost);
      break;
    }
    case MARK_UP_APPLY_TO_TYPES.retailPriceAndCost: {
      dbFeature.cost = getUpdatedFeaturePriceFromMarkItem(markUpItem, cost);
      dbFeature.price = getUpdatedFeaturePriceFromMarkItem(markUpItem, price);
      break;
    }
    case MARK_UP_APPLY_TO_TYPES.shippingCost: {
      dbFeature.shippingCost = getUpdatedFeaturePriceFromMarkItem(markUpItem, shippingCost);
      break;
    }
    case MARK_UP_APPLY_TO_TYPES.discount: {
      dbFeature.fabricatorCost = getUpdatedFeaturePriceFromMarkItem(markUpItem, discount);
      break;
    }
    default:
      break;
  }
  // console.log("newDbFeature", newDbFeature);
  return dbFeature
}

/**
 * @param markUpString {string}
 * @param dbFeature {dbFeatureInterface}
 * @return {dbFeatureInterface}
 */
const setFeaturePriceFromMarkItemOnLoad = (markUpString = "", dbFeature) => {
  if (!dbFeature || !markUpString) {
    return dbFeature
  }
  // console.log("markUpObject", markUpObject, newDbFeature);
  const markUpObject = JSON.parse(markUpString); // {Retail: {Type: "MarkUp", Value: 10}, Cost, Discount}

  if (Array.isArray(markUpObject)) { // QKB format
    // markUpObject.forEach(markUpListItem => { // removed, we should set it dynamically (after global)
      // console.log("dbFeature price cost", dbFeature.price, dbFeature.cost);
      // dbFeature = setFeaturePriceFromMarkItemQKB(markUpListItem, dbFeature);
      // console.log("dbFeature price cost", dbFeature.price, dbFeature.cost);
    // })
  } else if (typeof markUpObject === "object" && (markUpObject !== null)) { // CAES format!!
    // console.log("", markUpObject);
    // {
    //   Cost: {Type: 'MarkDown', Value: 10}
    //   Discount : {Type: 'MarkDown', Value: 0}
    //   Retail : {Type: 'MarkDown', Value: 10}
    // }
    Object.keys(markUpObject).forEach(key => {
      if (!markUpObject[key].Value || !MARK_UP_PROPS_MATCH[key]) {
        return
      }
      dbFeature[MARK_UP_PROPS_MATCH[key]] = getUpdatedFeaturePriceFromMarkItem(markUpObject[key], dbFeature[MARK_UP_PROPS_MATCH[key]], true);
    })
  }
  dbFeature.markUpString = markUpString; // just to be able to find it after job is saved on restore // and cases when global is applied first
  // console.log("newDbFeature", newDbFeature);
  return dbFeature
}

/**
 * returns which types of mark up should be applied to the price
 * @param fabricatorSettings {object}
 * @return {string[]}
 */
const getFeatureMarkUpApplyTo = (fabricatorSettings) => {
  if (fabricatorSettings?.useFabricatorCostPrices) {
    return [MARK_UP_APPLY_TO_TYPES.retailPrice, MARK_UP_APPLY_TO_TYPES.retailPriceAndCost]
  }
  if (fabricatorSettings?.showSalePrices) {
    return [MARK_UP_APPLY_TO_TYPES.discount]
  }
  return [MARK_UP_APPLY_TO_TYPES.cost, MARK_UP_APPLY_TO_TYPES.retailPriceAndCost]
}

/**
 *
 * @param currentPrice {number}
 * @param markUpString {string}
 * @param fabricatorSettings {object}
 * @return {number}
 */
export const updatePriceWithFeatureMarkUp = (currentPrice, markUpString, fabricatorSettings) => {
  if (!currentPrice || !markUpString) {
    return currentPrice
  }
  const markUpArray = JSON.parse(markUpString); // [{price, cost, shippingCost, discount}]
  if (!Array.isArray(markUpArray) || !markUpArray.length) {
    return currentPrice
  }
  const relevantTypes = new Set(getFeatureMarkUpApplyTo(fabricatorSettings))
  markUpArray.forEach(markUpItem => {
    if (relevantTypes.has(markUpItem.applyTo)) {
      currentPrice = getUpdatedFeaturePriceFromMarkItem(markUpItem, currentPrice)
    }
  })
  return currentPrice
}
